import { render, staticRenderFns } from "./ChatTest.vue?vue&type=template&id=bb869fae"
import script from "./ChatTest.vue?vue&type=script&lang=js"
export * from "./ChatTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports